import Layout from '@/layout'
const productRouter = {
  path: '/product',
  component: Layout,
  name: 'product',
  meta: {
    title: '产品管理',
    icon: 'el-icon-menu',
    roles: ['root', 'market']
  },
  children: [
    {
      path: 'table',
      name: 'ProductTable',
      component: () => import('@/views/product/table'),
      meta: { title: '产品列表', icon: 'el-icon-menu', roles: ['root', 'market'], noCache: false }
    }
  ]
}
export default productRouter
